import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { format } from "date-fns";
import { sv } from "date-fns/locale";
import i18next from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import { Text } from "../../Primitives";
import { ReplayListItemPoster } from "./ReplayListItemPoster";
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        display: "grid",
        gridAutoFlow: "column",
        alignItems: "center",
        gridGap: 16,
        color: "inherit",
        textDecoration: "none",
        position: "relative",
        gridTemplateColumns: ({ size }) => (size === "large" ? null : "110px 1fr"),
        gridTemplateRows: ({ size }) => (size === "large" ? "1fr auto" : null),
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: ({ size }) => (size === "large" ? null : "90px 1fr")
        },
        "&:before": {
            content: "''",
            background: theme.palette.primary.main,
            position: "absolute",
            top: -8,
            left: -12,
            right: -12,
            bottom: -8,
            borderRadius: 32,
            opacity: 0,
            transform: "scaleX(0.8) scaleY(0.7)",
            transition: "all 0.125s ease-out"
        },
        "&:hover": {
            "& svg": {
                transform: "scale(1.05)"
            },
            "&:before": {
                borderRadius: 12,
                opacity: 0.05,
                transform: "scale(1)"
            }
        }
    },
    freeIndicator: {
        backgroundColor: theme.palette.type === "dark" ? "#444" : "#eee",
        color: theme.palette.type === "dark" ? "#eee" : "#444",
        fontWeight: 600,
        display: "inline-block",
        lineHeight: 1.5,
        padding: "0 4px",
        borderRadius: "6px"
    }
}));
const useReplayDate = (replay) => {
    const { t } = useTranslation("replay");
    const time = replay.start instanceof Date ? replay.start : new Date(replay.start);
    const day = format(time, "cccc", {
        locale: i18next.language === "sv-SE" && sv
    });
    const date = time.getDate();
    const month = format(time, "MMMM", {
        locale: i18next.language === "sv-SE" && sv
    });
    const year = format(time, "yyyy", {
        locale: i18next.language === "sv-SE" && sv
    });
    return t("wasLiveAt", {
        day,
        date: `${date} ${month} ${year}`
    });
};
export const ReplayListItem = (props) => {
    var _a;
    const classes = useStyles(props);
    const date = useReplayDate(props.replay);
    const { t, ready } = useTranslation("categoryPicker");
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    if (!ready) {
        return null;
    }
    return (React.createElement(LazyLoad, null,
        React.createElement(Link, { className: classes.root, to: props.link || "" },
            React.createElement(ReplayListItemPoster, { replay: props.replay, link: props.link, size: props.size, startTime: props.startTime }),
            React.createElement("div", null,
                !props.replay.requiredProductAnytime && (React.createElement(Text, { variant: "body2", className: classes.freeIndicator }, t("free"))),
                React.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    } },
                    React.createElement(Text, { variant: isMobile ? "h5" : "h4", compact: isMobile, color: "primary", unselectable: true }, (_a = props.program) === null || _a === void 0 ? void 0 : _a.title),
                    props.likeable),
                React.createElement(Text, { variant: isMobile ? "body2" : "body1", compact: isMobile, unselectable: true }, date)))));
};
//# sourceMappingURL=ReplayListItem.js.map